module.exports = __webpack_public_path__ + "img/four-color-deck-kicker.1ae9a46f.png";